import useTranslate from '../../../i18n/useTranslate'
import { Form as FinalForm } from 'react-final-form'
import { Button, Grid, makeStyles } from '@material-ui/core'
import MyTextfield from '../../../control/textfield/textfield'
import { RiskProjectRequest } from '../../../services/um/useSearchRiskProjectSummary'

type ClosePanelComponentProps = {
    onSubmit: (value: RiskProjectRequest) => void
    initialValue: RiskProjectRequest
    onClear: (form: any) => void
}

const Panel = ({ onSubmit, initialValue, onClear }: ClosePanelComponentProps) => {
    const classes = useStyles()
    const translate = useTranslate()

    return (
        <Grid className={classes.root}>
            <FinalForm onSubmit={onSubmit} initialValues={initialValue}>
                {({ handleSubmit, form, values }) => {
                    return (
                        <Grid container spacing={2} className={classes.container}>
                            <Grid item xs={12}>
                                <MyTextfield
                                    name="keyword"
                                    materialInputProps={{
                                        disabled: false,
                                        label: translate.get('UM.RISK_PROJECT_SUMMARY.KEYWORD.LABEL'),
                                        placeholder: translate.get('UM.RISK_PROJECT_SUMMARY.KEYWORD.PLACEHOLDER'),
                                        size: 'small',
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container justify="flex-end" spacing={2}>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="default"
                                            onClick={() => onClear(form)}
                                        >
                                            {translate.get('BUTTON.RESET')}
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button
                                            size={'large'}
                                            fullWidth
                                            variant="contained"
                                            color="primary"
                                            onClick={handleSubmit}
                                        >
                                            {translate.get('BUTTON.SEARCH')}
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )
                }}
            </FinalForm>
        </Grid>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        padding: '1.7rem',
    },
    root: {
        width: '100%',
    },
}))

export default Panel
